import React from 'react'
import config from '../../config';

import { Row, Col, Card, Input, Typography } from 'antd'

import './autobot.css'

const { Title } = Typography

export default function (props) {

  const templates = props.autobotProps.botTemplates.map((bot) => {
    return drawCard(
      bot.template_info.title,
      bot.template_info.description,
      `${config.api.host}/api/v1/files/bot/template/image/${bot.template_info.image}`,
      bot.id,
      props.autobotProps.selectedTemplate,
      () => {
        props.autobotProps.handleOnSelectTemplate(bot.id)
      },
    )
  })

  return (
    <div style={{ width: '80%', margin: 'auto' }}>
      <Row>
        <Col xs={24} className="text-center">
          <Title level={3}>Setup Your Apply-By-Text Bot</Title>
        </Col>
      </Row>
      <Row style={{ marginTop: '10px' }} align="middle">
        <Col xs={8} className="setting-label">
          <span>Brand Name:</span>
        </Col>
        <Col xs={14}>
          <Input
            placeholder="This will show up on your Bot's welcome message"
            value={props.autobotProps.brandName}
            onChange={(e) => props.autobotProps.handleOnChange('brandName')(null, e.target.value)}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '10px' }} align="middle">
        <Col xs={8} className="setting-label">
          <span>Career Site URL:</span>
        </Col>
        <Col xs={14}>
          <Input
            placeholder="Forward applicants to your career site"
            value={props.autobotProps.careerSiteUrl}
            onChange={(e) => props.autobotProps.handleOnChange('careerSiteUrl')(null, e.target.value)}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col xs={24} className="text-center" style={{ marginBottom: '16px' }}>
          <Title level={4}>Select a template</Title>
        </Col>
      </Row>
      <Row style={{ marginBottom: '16px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
        {templates}
      </Row>
    </div>
  )
}

function drawCard(title, description, image, id, selectedTemplate, onTapCard) {
  const active = selectedTemplate === id
  return (
    <div onClick={onTapCard} key={id}>
      <Card
        className={`template-card ${active ? '' : 'template-card-inactive'}`}
        style={{ minHeight: '240px' }}
        cover={
          <div style={{ padding: '10px' }}>
            <img src={image} className="template-card-img" alt="" />
          </div>
        }
      >
        <div className="template-card-text">
          <span
            style={{
              display: 'block',
              fontSize: '1.2em',
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: '10px'
            }}
          >
            {title}
          </span>
          {description}
          <div className="select-btn">{active ? "Selected" : "Select"}</div>
        </div>
      </Card>
    </div>
  )
}
